export const ROOT = `/gift-card`;
